/**
 * @generated SignedSource<<bb54c869f2158a80db12cc88112b77a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseModalContainer_photo$data = {
  readonly name: string | null;
  readonly path: string | null;
  readonly room: {
    readonly name: string | null;
    readonly urlLabel: string | null;
    readonly value: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly styles: ReadonlyArray<{
    readonly name: string | null;
    readonly urlLabel: string | null;
    readonly value: string | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseFirmDetailsRenderer_searchBrowsePhoto" | "interiorsPhotosTracking_searchBrowsePhoto">;
  readonly " $fragmentType": "PhotosSearchBrowseModalContainer_photo";
};
export type PhotosSearchBrowseModalContainer_photo$key = {
  readonly " $data"?: PhotosSearchBrowseModalContainer_photo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseModalContainer_photo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowseModalContainer_photo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotosSearchBrowseFirmDetailsRenderer_searchBrowsePhoto"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "interiorsPhotosTracking_searchBrowsePhoto",
      "selections": [
        (v0/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhotoStyle",
      "kind": "LinkedField",
      "name": "styles",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhotoStyle",
      "kind": "LinkedField",
      "name": "room",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v1/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowsePhoto",
  "abstractKey": null
};
})();

(node as any).hash = "99e66b835547574a3d7d0103660172fb";

export default node;
